<div class="product-group">
    <div class="group-title">
        {{ translationKey | translate }}
    </div>
    <div class="group-items">
        <div class="group-item" *ngFor="let prod of products">
            <div class="item-material">
                {{ prod.quantity }} x {{ prod.material }}
                <app-product-details
                    [productDescription]="chooseTranslation(prod.translation)"
                    [material]="prod.material"
                    [productDetails]="prod.productListDetails"
                    *ngIf="
                        prod.productListDetails?.length ||
                        (prod.productReferences && prod.productReferences.packageContents)
                    "
                ></app-product-details>
            </div>
            <div class="item-name" [innerHTML]="chooseTranslation(prod.translation)"></div>
        </div>
    </div>
</div>
